import { Button, Card } from "antd";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setProgram } from "src/store/slices/auth";
import Config from "../../config";

const programs = Object.entries(Config);

export default function ProgramPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <div className="bg-primary-hover flex gap-8 flex-col items-center justify-center h-screen w-screen">
      <h1 className="text-3xl font-semibold text-white">Select a Program</h1>
      <div className="flex flex-wrap items-center justify-center gap-4">
        {programs.map(([id, program]) => (
          <Button
            onClick={() => {
              dispatch(setProgram({ programId: id }));
              navigate(`/program/login/${id}`);
            }}
            variant="link"
            className="p-0 w-fit h-fit"
          >
            <Card
              className="flex w-fit items-center text-center justify-center px-8"
              key={id}
            >
              <img
                className="w-36 h-36 object-contain"
                src={program.image}
                alt={program.name}
                onError={(e) => {
                  if (!e.currentTarget.src.endsWith("logo192.png")) {
                    e.currentTarget.src = "/logo192.png";
                  }
                }}
              />
              <h2 className="mt-4 text-lg font-semibold">{program.name}</h2>
            </Card>
          </Button>
        ))}
      </div>
    </div>
  );
}
